import { render, staticRenderFns } from "./CustomFieldsAttributes.vue?vue&type=template&id=a0562128"
import script from "./CustomFieldsAttributes.vue?vue&type=script&lang=js"
export * from "./CustomFieldsAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports